import { useEffect, useState } from "react";
import useTitleStore from "../../store/titleStore";
import useDebounce from "../../hooks/useDebounce";
import { useTableHeight } from "../../hooks/useTableHeight";
import { useNavigate } from "react-router";
import { Button, Card, Flex, Form, Grid, Input, Modal, Pagination, Popover, Select, Space, Table } from "antd";
import { Icon } from "@iconify/react/dist/iconify.js";
import { registrationService } from "../../services/registration.service";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import RenderIf from "../../components/RenderIf";
import { useAuth } from "../../hooks/useAuth";
import { indonesiaRegionService } from "../../services/indonesia-region.service";
import { useLocalStorage } from "../../hooks/useLocalStorage";

export default function SurveyIndex() {

  const breakpoint = Grid.useBreakpoint()

  const navigate = useNavigate();

  const { user } = useAuth()

  const { setTitle } = useTitleStore();

  const tableHeight = useTableHeight();

  const [keyword, setKeyword] = useState("");
  const [marketing, setMarketing] = useState("");
  const [selectedCity, setSelectedCity] = useState('')
  const [responsiveFilter, setResponsiveFilter] = useState(false)
  const [selectedDistrict, setSelectedDistrict] = useState('')
  const debouncedKeyword = useDebounce(keyword, 500);
  const debouncedMarketing = useDebounce(marketing, 500);

  const [marketingQuery, setMarketingQuery] = useLocalStorage('surveyorQuery', debouncedMarketing);

  const [filterForm] = Form.useForm()

  const city = Form.useWatch('city', filterForm)
  const district = Form.useWatch('district', filterForm)
  const village = Form.useWatch('village', filterForm)

  const [dataParams, setDataParams] = useState({
    limit: 10,
    page: 1,
    filter: []
  })

  useEffect(() => {
    setTitle("Survey Pelanggan");
    setMarketing(marketingQuery)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataParams({
      ...dataParams,
      filter: [
        {
          operator: 'orWhere',
          value: [
            {
              field: 'surveyor',
              operator: 'like',
              value: debouncedKeyword
            },
            {
              field: 'nama_kustomer',
              operator: 'like',
              value: debouncedKeyword
            },
            {
              field: 'nomor_kustomer',
              operator: 'like',
              value: debouncedKeyword
            },
            {
              field: 'tracking_id',
              operator: 'like',
              value: debouncedKeyword
            },
            {
              field: 'rt_kustomer',
              operator: 'like',
              value: debouncedKeyword
            },
            {
              field: 'rw_kustomer',
              operator: 'like',
              value: debouncedKeyword
            },
          ]
        },
        {
          field: 'marketing',
          operator: 'like',
          value: debouncedMarketing
        },
        {
          field: 'kota_kustomer',
          operator: 'like',
          value: city
        },
        {
          field: 'kecamatan_kustomer',
          operator: 'like',
          value: district
        },
        {
          field: 'kelurahan_kustomer',
          operator: 'like',
          value: village
        },
      ]
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedKeyword, city, district, village, debouncedMarketing]);


  const { data: registrationData, isLoading, isRefetching } = useQuery({
    queryKey: ['registration', dataParams],
    queryFn: () => registrationService.getDataForSurveyor(dataParams),
    placeholderData: keepPreviousData,
  })

  const handleChangePage = (page, pageSize) => {
    setDataParams({
      ...dataParams,
      limit: pageSize,
      page
    })
  }

  const handleChangeMarketingQuery = (q) => {
    setMarketingQuery(q)
    setMarketing(q)
  }

  const { data: cities } = useQuery({
    queryKey: ['cities'],
    queryFn: () => indonesiaRegionService.getCities()
  })

  const { data: districts } = useQuery({
    queryKey: ['districts', selectedCity],
    queryFn: () => indonesiaRegionService.getDistricts(selectedCity),
    enabled: !!selectedCity
  })

  const { data: villages } = useQuery({
    queryKey: ['districts', selectedDistrict],
    queryFn: () => indonesiaRegionService.getSubdistricts(selectedDistrict),
    enabled: !!selectedDistrict
  })

  console.log(districts)

  useEffect(() => {

    filterForm.resetFields(['district', 'village'])

    if (city) {
      const selected = cities.find(e => e.name == city)
      setSelectedCity(selected.id)
      console.log(selected)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [city])

  useEffect(() => {

    filterForm.resetFields(['village'])

    if (district) {
      const selected = districts.find(e => e.name == district)
      setSelectedDistrict(selected.id)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [district])


  const columns = [
    {
      title: 'No',
      align: 'center',
      width: 80,
      fixed: breakpoint.md && 'left',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Tracking ID',
      dataIndex: 'tracking_id',
      width: 150,
      fixed: breakpoint.md && 'left',
    },
    {
      title: 'Nama Pelanggan',
      dataIndex: 'nama_kustomer',
      width: 180
    },
    {
      title: 'No Telp',
      dataIndex: 'nomor_kustomer',
      width: 230
    },
    {
      title: 'Kota',
      dataIndex: 'kota_kustomer',
      width: 180,
    },
    {
      title: 'Kelurahan',
      dataIndex: 'kelurahan_kustomer',
      width: 150,
    },
    {
      title: 'RT/RW',
      width: 120,
      render: val => `${val.rt_kustomer?.toString().padStart(3, '0')}/${val.rw_kustomer?.toString().padStart(3, '0')}`
    },
    {
      title: 'Surveyor',
      dataIndex: 'acceptance',
      width: 150,
      render: val => val?.surveyor?.name
    },
    {
      title: 'Marketing',
      dataIndex: 'acceptance',
      width: 150,
      render: val => val?.surveyor?.marketing?.name
    },
    {
      className: 'last-cell-p',
      title: 'Aksi',
      align: 'right',
      width: 80,
      fixed: 'right',
      render: (record) => (
        <Popover content="Isi Form Survey" placement="left" >
          <Button
            icon={<Icon icon="solar:document-add-bold-duotone" width="18" height="18" />}
            color="primary"
            variant="filled"
            onClick={() => navigate('/survey/detail/' + record.acceptance.survey.id)}
            size=""
          />
        </Popover>
      )
    },
  ]

  return (
    <>
      <Card
        styles={{
          body: {
            paddingLeft: 0,
            paddingRight: 0
          }
        }}
      >
        <RenderIf when={breakpoint.lg} >
          <Form form={filterForm} >
            <Flex gap={20} justify="space-between" style={{ paddingInline: 24, marginBottom: 24 }} >
              <Input
                style={{ width: 250 }}
                prefix={<Icon icon="hugeicons:search-01" width="16" height="16" />}
                placeholder="cari..."
                onChange={e => setKeyword(e.target.value)}
                value={keyword}
              />
              <Input
                prefix={<Icon icon="solar:user-rounded-linear" width="16" height="16" />}
                style={{ width: 220 }}
                placeholder="Marketing"
                onChange={e => handleChangeMarketingQuery(e.target.value)}
                value={marketing}
                allowClear
              />
              <Form.Item noStyle name={'city'} >
                <Select
                  allowClear
                  options={cities?.map(e => ({ label: e.name, value: e.name }))}
                  style={{ width: 200 }}
                  placeholder="Kota"
                />
              </Form.Item>
              <Form.Item noStyle name={'district'} >
                <Select
                  allowClear
                  options={districts?.map(e => ({ label: e.name, value: e.name }))}
                  style={{ width: 200 }}
                  placeholder="Kecamatan"
                  disabled={!city}
                />
              </Form.Item>
              <Form.Item name={'village'} noStyle >
                <Select
                  allowClear
                  options={villages?.map(e => ({ label: e.name, value: e.name }))}
                  style={{ width: 200, marginRight: 'auto' }}
                  placeholder="Kelurahan"
                  disabled={!district}
                />
              </Form.Item>
              <RenderIf when={user?.user?.subdivision == 'Surveyor'} >
                <Button
                  variant="solid"
                  color="primary"
                  icon={<Icon icon="duo-icons:add-circle" width="22" height="22" />}
                  onClick={() => navigate('/survey/create')}
                >
                  Tambah Sambungan Baru
                </Button>
              </RenderIf>
            </Flex>
          </Form>
        </RenderIf>
        <RenderIf when={!breakpoint.lg} >
          <Flex gap={20} style={{ padding: '0 24px', marginBottom: 24 }} >
            <Button
              block
              variant="outlined"
              color="primary"
              icon={<Icon icon="mynaui:filter-solid" width="22" height="22" />}
              onClick={() => setResponsiveFilter(true)}
            >
              Filter
            </Button>
            <Button
              variant="solid"
              color="primary"
              icon={<Icon icon="duo-icons:add-circle" width="22" height="22" />}
              onClick={() => navigate('/survey/create')}
              block
            >
              Tambah Sambungan Baru
            </Button>
          </Flex>
        </RenderIf>
        <Table
          id="registration-table"
          columns={columns}
          size="small"
          loading={isLoading || isRefetching}
          rowKey={'id'}
          scroll={{ y: tableHeight }}
          dataSource={registrationData?.data}
          pagination={false}
          rowClassName={(record) => !record.is_open ? 'row-open' : ''}
        />
        <Pagination
          style={{ marginInline: 24, marginTop: 16 }}
          total={registrationData?.pagination?.total}
          showSizeChanger
          pageSizeOptions={['10', '20', '50']}
          current={registrationData?.pagination?.page}
          pageSize={dataParams.limit}
          align="end"
          onChange={handleChangePage}
        />
      </Card>
      <Modal
        open={responsiveFilter}
        centered
        title="Filter"
        onCancel={() => setResponsiveFilter(false)}
        onOk={() => setResponsiveFilter(false)}
      >
        <Form form={filterForm} >
          <Space size={'large'} direction="vertical" style={{ width: '100%', margin: '20px 0' }}  >
            <Input
              prefix={<Icon icon="hugeicons:search-01" width="16" height="16" />}
              placeholder="cari.."
              onChange={e => setKeyword(e.target.value)}
              value={keyword}
            />
            <Input
              prefix={<Icon icon="solar:user-rounded-linear" width="16" height="16" />}
              placeholder="Marketing"
              onChange={e => handleChangeMarketingQuery(e.target.value)}
              value={marketing}
              allowClear
            />
            <Form.Item noStyle name={'city'} >
              <Select
                allowClear
                style={{ width: '100%' }}
                options={cities?.map(e => ({ label: e.name, value: e.name }))}
                placeholder="Kota"
              />
            </Form.Item>
            <Form.Item noStyle name={'district'} >
              <Select
                allowClear
                style={{ width: '100%' }}
                options={districts?.map(e => ({ label: e.name, value: e.name }))}
                placeholder="Kecamatan"
                disabled={!city}
              />
            </Form.Item>
            <Form.Item noStyle name={'village'}  >
              <Select
                allowClear
                style={{ width: '100%' }}
                options={villages?.map(e => ({ label: e.name, value: e.name }))}
                placeholder="Kelurahan"
                disabled={!district}
              />
            </Form.Item>
          </Space>
        </Form>
      </Modal>
    </>
  )
}